// extracted by mini-css-extract-plugin
export default {"columns":"NotesColumns_columns__8eyMy"};